import { FilterType } from 'portal-commons';
import { DateRangePresets } from '../../constants';
import {
  getBrandNameAutocompleteOptions,
  getCspNameAutocompleteOptions,
} from '@/apis/services';

export const FILTER_CONFIG = {
  uid: {
    type: FilterType.Text,
    label: 'Campaign ID',
    placeholder: 'Enter Campaign ID',
  },
  googleAgentId: {
    type: FilterType.Text,
    label: 'Google Agent ID',
    placeholder: 'Enter Google Agent ID',
  },
  brandUid: {
    type: FilterType.Text,
    label: 'Brand ID',
    placeholder: 'Enter Brand ID',
  },
  brandName: {
    type: FilterType.Text,
    label: 'Brand DBA Name',
    placeholder: 'Enter Brand DBA Name',
    suggestions: [],
  },
  cspName: {
    type: FilterType.Text,
    label: 'CSP DBA Name',
    placeholder: 'Enter CSP DBA Name',
    suggestions: [],
  },
  dcaUid: {
    type: FilterType.Dropdown,
    options: [],
    label: 'DCA Name',
    placeholder: 'DCA Name',
  },
  usecase: {
    type: FilterType.Dropdown,
    options: [],
    label: 'Use Case',
    placeholder: 'Use Case',
  },
  billingCategory: {
    type: FilterType.Dropdown,
    options: [],
    label: 'Billing Category',
    placeholder: 'Billing Category',
  },
  createDate: {
    type: FilterType.DateRange,
    label: 'Registered On',
    placeholder: 'Select Date Range',
    dateRangePresets: DateRangePresets,
    delayUpdate: false,
  },
  status: {
    type: FilterType.Dropdown,
    options: [
      { label: 'ACTIVE', value: 'ACTIVE' },
      { label: 'DEACTIVATED', value: 'EXPIRED' },
    ],
    label: 'TCR Status',
    placeholder: 'TCR Status',
  },
  mnoStatus: {
    type: FilterType.Dropdown,
    options: [
      {
        label: 'ACTIVE',
        value: 'ACTIVE',
      },
      {
        label: 'SUSPENDED',
        value: 'SUSPENDED',
      },
      {
        label: 'REJECTED',
        value: 'REJECTED',
      },
      {
        label: 'TERMINATED',
        value: 'TERMINATED',
      },
    ],
    label: 'MNO Status',
    placeholder: 'MNO Status',
    multiple: true,
    width: 250,
  },
};

export const TABLE_HEADERS = [
  { id: 'uid', label: 'CAMPAIGN ID', sortable: true },
  { id: 'googleAgentId', label: 'GOOGLE AGENT ID', sortable: false },
  { id: 'brandUid', label: 'BRAND ID', sortable: true },
  { id: 'brandName', label: 'BRAND DBA NAME', sortable: false },
  { id: 'cspName', label: 'CSP DBA NAME', sortable: true },
  { id: 'dcaName', label: 'DCA NAME', sortable: false },
  { id: 'usecase', label: 'USE CASE', sortable: false },
  { id: 'billingCategory', label: 'BILLING CATEGORY', sortable: false },
  { id: 'createDate', label: 'REGISTERED ON', sortable: true },
  { id: 'status', label: 'TCR STATUS', sortable: false },
  { id: 'mnoStatus', label: 'MNO STATUS', sortable: false },
];

export const FILTER_LOADERS = {
  suggestion: {
    brandName: {
      minLength: 2,
      load: (value: string) =>
        getBrandNameAutocompleteOptions('displayName', value),
    },
    cspName: {
      minLength: 2,
      load: (value: string) =>
        getCspNameAutocompleteOptions('displayName', value),
    },
  },
};
